import { render } from "./AppHeaderDropdownAccount.vue?vue&type=template&id=57c3c7a6&scoped=true"
import script from "./AppHeaderDropdownAccount.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownAccount.vue?vue&type=script&lang=js"

import "./AppHeaderDropdownAccount.vue?vue&type=style&index=0&id=57c3c7a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c3c7a6"]])

export default __exports__